<template>
  <div class="card wrapper">
    <button
      v-focus
      type="button"
      class="icon clickable-bigicon"
      aria-label="Vers les articles"
      @click="$emit('clickIcon')"
      @keydown.enter.prevent="$emit('clickIcon')"
    >
      <i class="fa-kit fa-sv-articles" />
    </button>
    <div v-if="props.isLoading">
      <MinerveOrbite />
    </div>
    <div v-else class="metrics">
      <div class="primary-metric">
        <span class="value">{{ SINumberFormatter(props.articlesCount) }}</span>
        Articles
      </div>
    </div>
  </div>
</template>

<script setup>
import MinerveOrbite from "@follaw-fr/components/reusable/minerve/MinerveOrbite.vue";

import { SINumberFormatter } from "@follaw-fr/utils/helper.utils";

const props = defineProps({
  isLoading: { type: Boolean, required: true },
  articlesCount: { type: Number, default: 0 },
});

defineEmits(["clickIcon"]);
</script>

<style scoped lang="scss">
.wrapper {
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  --context-color: var(--clr-service-article);

  .clickable-bigicon {
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 65px;
  height: 65px;
  border-radius: 50%;

  font-size: 2rem;
  background-color: var(--context-color);
  color: white;
}

.metrics {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.primary-metric {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  font-size: 1.2rem;
  color: black;

  .value {
    font-size: 2.2rem;
  }
}

.value {
  color: var(--context-color);
}
</style>
